import React from 'react';
import { NativeSelect } from '@material-ui/core';
import styled from 'styled-components';
import { ORGANISATION_PLANS } from './organisationPlans';

export default function OrganisationPlanSelect({ plan, onChange, disabled }) {
  return (
    <Container>
      <Label htmlFor="organisation-plan">Plan</Label>
      <NativeSelect id="organisation-plan" value={plan ?? ''} disabled={disabled} onChange={event => onChange(event.target.value)}>
        {!plan && (
          <option value="" disabled>
            No plan
          </option>
        )}
        {ORGANISATION_PLANS.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </NativeSelect>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Label = styled.label`
  font-size: 25px;
  font-weight: 600;
  color: #2f9d6d;
`;
